export default __webpack_public_path__ + "d780f37710fb73f7d809a7a0ded42b21.png";